import React from 'react';
import idcardcss from '../pages/css/idcard.module.css';
import { useState } from 'react';
import { useEffect } from 'react';
import { createdoctype, changedoctype } from '../tools/filehandler';
import { setErrorMessage } from "../tools/errorhandling";
import { CgCloseR } from "react-icons/cg";
import Button from 'react-bootstrap/Button';



const AddDocumentType = ({ rights, t, id, description, events }) => {
    useEffect(() => {
        document.getElementById("doctype_description").value = description;
    }, [id]);

    const create_newdocumenttype = (documenttypedescription) => {
        if (id !== null) {
            if (documenttypedescription) {
                changedoctype(documenttypedescription, id).then((res) => {
                    console.log("status =", res.status)
                    if (res.status === 200) {
                        events.loaddocumenttypes()
                        events.handleCancel()

                    } else {
                        setErrorMessage(res.statusText)
                    }
                })
                events.loaddocumenttypes()
                handleCancel()
            }
        }
        else {
            if (documenttypedescription) {
                createdoctype(documenttypedescription).then((res) => {
                    //console.log("status =", res.status)
                    if (res.status === 200) {
                        events.loaddocumenttypes()
                        handleCancel()

                    } else {
                        setErrorMessage(res.statusText)
                    }
                })
            }
        }
    }
    const handleCancel = () => {
        document.getElementById("coverAll").style.display = 'none'

    }
    // 
    return (
        <div id="add_documenttype" className='focusOfTheDay'>
            <div className='formcaption' onMouseDown={(e) => events.startdrag("add_documenttype", true, e)} onMouseUp={(e) => events.startdrag(null, false, e)}>{t(id? 'ChangeFolderName': 'AddFolder')} <CgCloseR className='closer' onClick={events.handleCancel} /></div>
            <div className="AssignCleaningform">
                <label className='labelhotel' style={{ padding: '12px' }}>
                    {t('Naam')}:
                </label>
                <input id="doctype_description" name="title" className="doublegrid" type='text'>
                </input>
                &nbsp;
                <div className='messageBoxes'>
                    <Button type="button" id="CloseMessageButton" className="OkCancel messageBoxAlignRight" onClick={() => create_newdocumenttype(document.getElementById("doctype_description").value)}>{t("OK")}</Button>
                    <Button type="button" id="CancelMessageButton" className="OkCancel messageBoxAlignleft" onClick={handleCancel}>{t("Cancel")}</Button>
                </div>
            </div>

        </div>
    );
};


export default AddDocumentType;
